export default {
	empty: 'Please input',
	fuzhicg: 'Success',
	fuzhicc: 'Error',
	error:{
		notNull: 'Not be NULL',
		notYes: 'Non-compliant'
	},
  login: {
    signUp:'Sลงชื่อ', 
    title: 'กระเป๋าเงินสากลสำหรับสินทรัพย์ดิจิทัลทั้งหมดของคุณ',
    submit: 'เข้าสู่ระบบ',
    username: 'กรุณากรอกหมายเลขโทรศัพท์ของท่าน',
    password: 'กรุณาใส่รหัสผ่านของคุณ',
    verifycode:'กรุณากรอก captcha',
    forget_password:'ลืมรหัสผ่านหรือไม่?',
	no_account:'ไม่มีบัญชี AuWallet?',
    register:'ลงทะเบียน',
    verifycode_tip:'โปรดป้อน captcha',
    verifycode_error:'captcha . ไม่ถูกต้อง'
  },
  register:{
    title:'ลงทะเบียน',
    username:'หมายเลขโทรศัพท์',
    get_code:'รับรหัส',
    verifycode:'รหัสยืนยัน',
    password:'รหัสผ่าน',
    repeat:'ยืนยัน',
    invite_code:'รหัสเชิญ',
    submit:'ลงทะเบียน',
    registered:'มีบัญชีแล้ว',
    go_login:'เข้าสู่ระบบ'
  },
  nologin:{
    cloud_wallet:'กระเป๋าเงินคลาวด์',
    cloud1:'การป้องกันความปลอดภัยสูงสุด',
    cloud2:'รับสินทรัพย์ที่ไม่ซ้ำใคร ลงทะเบียนและฝากเหรียญเพื่อเพลิดเพลินกับรายได้',
    cloud3:'รองรับเหรียญกระแสหลักมากกว่า 30+ เหรียญและโทเค็นมากกว่า 500 รายการ',
    button1:'ลงทะเบียน',
    button2:'เข้าสู่ระบบ',
    button_oauth: 'เข้าสู่ระบบด้วย 2U.Chat',
    hd_wallet:'กระเป๋าสตางค์ HD',
    hd1:'ควบคุมคีย์ส่วนตัวได้ 100% ทรัพย์สินที่มั่นใจมากขึ้น',
    hd2:'นำเข้าคำช่วยจำในคลิกเดียวสะดวกและใช้งานง่าย',
    hd3:'รองรับเหรียญกระแสหลักมากกว่า 30+ เหรียญและโทเค็นมากกว่า 500 รายการ',
    button3:'ลงทะเบียน',
    button4:'เข้าสู่ระบบ',
    doLogin:"คลิกเพื่อเข้าสู่ระบบ",
    welcomeTo:"ยินดีต้อนรับสู่ AuWallet",
  },
  forget:{
    title:'ลืมรหัสผ่าน? ',
    phone_number:'หมายเลขโทรศัพท์',
    verify_code:'รหัสยืนยัน',
    password:'รหัสผ่าน',
    repeat:'ย้ำอีกครั้ง',
    submit:'ยืนยัน'
  },
  footer:{
    nav1:'กระเป๋าสตางค์',
    nav2:'ตลาด',
    nav3:'สินทรัพย์',
    nav4:'ค้นพบ',
    nav5:'ของฉัน'
  },
  home:{
    total:'สินทรัพย์รวม',
    invite:'เชิญเพื่อน ๆ',
    redbag:'ส่งซองแดง',
    exchange:'แลกเปลี่ยน',
    scan:'สแกน',
    address_book:'สมุดที่อยู่',
    notice:'ประกาศ',
    setting:'การตั้งค่า',
    view_mnemonic:'ดู Mnemonic',
    backup_mnemonic:'ตัวช่วยจำสำรอง',
    create_wallet:'สร้างกระเป๋าสตางค์',
    import_wallet:'นำเข้ากระเป๋าสตางค์', 
    welcome:'ยินดีต้อนรับ',
	cant9sale: 'KYC must pass level 2 or above and have never participated in a 10% discount event.'
  },
  
  address:{
    new_address:'ที่อยู่ใหม่',
    name:'ชื่อ',
    address:'ที่อยู่',
    submit:'สร้าง',
	warning_msg: 'โปรดทราบว่าที่อยู่นี้จะได้รับเฉพาะ erc20 สัญลักษณ์กรุณาอย่าเลือกช่องผิดเมื่อโอนเงิน'
  },
  swap:{
    title:'สลับแฟลช',
    pay:'คุณควรจ่าย ',
    balance:'ยอดเงินคงเหลือ',
    lock_rate:'กรุณาชำระเงินภายในเวลาต่อไปนี้เพื่อล็อคอัตราแลกเปลี่ยนนี้',
    gain:'คุณจะได้รับ ',
    input:'กรุณากรอกจำนวนเงิน',
    tip:'เมื่อสกุลเงินที่คุณได้รับว่างเปล่า หมายความว่าไม่มีสกุลเงินให้แฟลชสวอป',
    submit:'สลับตอนนี้',
    choose_coin:'เลือกเหรียญ',
	notice_2ut: 'ฉันได้อ่านประกาศนี้แล้ว'
  },
  coin:{
    send:'ส่ง',
    swap:'แลกเปลี่ยน',
    receive:'ได้รับ',
    transactions:'ธุรกรรม',
    type1:'คลาวด์ออก',
    type2:'เมฆใน',
    type3:'แลกเปลี่ยน',
    type4:'การเงิน',
    type7:'HD ออก',
    type8:'HD ใน',
    type9:'ส่งซองแดง',
    type10:'รับซองแดง',
	type11:'AuWallet transfer out TimeEx',
	type12:'TimeEx transfer in AuWallet',
	type13: 'Chain shopping service fee',
	type14: '10% Off shopping service fee',
	type15: 'Withdrawal',
	type16: 'KYC Certification fees',
    flushing:'ฟลัชชิง...',
    loading:'กำลังโหลด...',
    no_records:'ไม่มีบันทึก',
    wallet:' กระเป๋าสตางค์',
    tx_time:'เวลาทำรายการ',
    tx_id:'ไอดี',
    tx_from:'จาก',
    tx_to:'ถึง',
    tx_memo:'ข้อสังเกต',
    tx_status1:'ล้มเหลว',
    tx_status2:'ที่รอ',
    tx_status3:'ความสำเร็จ',
    tx_status4:'รอดำเนินการ',

    receive_address:'กรุณาใส่ที่อยู่รับ',
    balance:'สมดุล',
    fee:'ค่าธรรมเนียม',
    send_all:'ส่งทั้งหมด',
    gas_fee:'ค่าน้ำมัน',
    slow:'ช้า',
    fast:'เร็ว',
    send:'ส่ง',
    tx_password:'กรุณาใส่รหัสผ่านการชำระเงิน',
    tx_remark:'หมายเหตุ (ไม่บังคับ)',
    address_book1:'สมุดที่อยู่บนคลาวด์',
    address_book2:'สมุดที่อยู่ HD',
    need_pay_pass:'กรุณาตั้งรหัสผ่านการชำระเงินก่อน',
    need_pin:'โปรดไปที่ศูนย์ส่วนบุคคลเพื่อตั้งรหัสพิน',

    
    set_receive_amount:'กำหนดจำนวนเงินที่ได้รับ',
    receive_amount:'รับจำนวน',
    copy_receive_code:'คัดลอกรหัสการชำระเงิน',
    confirm:'ยืนยัน',
    cancel:'ยกเลิก',
    rcv_address:'รับที่อยู่',
    search:'ป้อนเนื้อหาการค้นหา',
    filter:'กรอง',
    remove:'ลบ',
    add:'เพิ่ม',

    filter1:'สกุลเงินทั้งหมด',
    filter2:'เพิ่ม',
    filter3:'ไม่ได้เพิ่ม',
    
    notices:'ประกาศเกี่ยวกับกระเป๋าสตางค์ HD',
    notices2:'ประกาศเกี่ยวกับ Cloud Wallet',
	only_bitcoin: 'มีเพียงธุรกรรมบิตที่นี่',
	only_eth: 'ธุรกรรม ETH เท่านั้นที่นี่',
	only_usdt: 'ที่นี่มีเพียง USDT erc20 ธุรกรรม',
	only_2ut: 'ธุรกรรม 2ut เท่านั้นที่นี่',
	only_u2u: 'เหรียญ U2U เท่านั้น',
	only_2u: 'จุด 2U เท่านั้น',
	only_a2u: 'โอน A2U เท่านั้น',
	import: 'Import',
	info: 'Token overview'
  },

  market:{
    title:'ตลาด',
    coin:'สินทรัพย์',
    volume:'ปริมาณ',
    price:'ราคา',
    change:'เปลี่ยน (24H)',
  },

  discover:{
    title:'ค้นพบ',
    popular:'เป็นที่นิยม',
    all:'ทั้งหมด'
  },

  my:{
    title:'ของฉัน',
    notice:'ประกาศ',
    login:'คลิกเพื่อเข้าสู่ระบบ ',
    welcome:'ยินดีต้อนรับสู่ AuWallet',
    invite:'รางวัลคำเชิญ',
    news:'เดลี่ เอ็กซ์เพรส',
    contact:'บริการลูกค้า',
    pin_on:'บน',
    pin_off:'ปิด',
    default_currency:'สกุลเงินเริ่มต้น',
    red_green:'ตัวเลือกใบเสนอราคา',
    option1:'เขียวขึ้นแดงลง',
    option2:'แดงขึ้นเขียวลง',
    contract:'สัญญาการให้บริการ',
    privacy:'นโยบายความเป็นส่วนตัว',
    help:'ศูนย์ช่วยเหลือ',
	invite: 'My Invite code',
	onequan: 'My Business Circle',
	copy: 'Copy',
	total: 'Total',
	downloadapp: 'Download mobile APP.',
	download: 'Download',
	waiting: 'Waiting Or Use',
	reenxv: 'GreenX Vcode',
	greenxvet: 'Can use'
  },
  setup:{
    title:'การตั้งค่ากระเป๋าสตางค์',
    pay_password:'จ่ายรหัสผ่าน',
    on:'บน',
    off:'ปิด',
    google:'การยืนยันของ Google',
    security_level:'ระดับความปลอดภัย',
    account_name:'ชื่อบัญชี',
    logout:'ออกจากระบบ',
    register_time:'เวลาลงทะเบียน',
    level:'ระดับ',
    modify_pay_password:'แก้ไขรหัสผ่านการชำระเงิน',
    reset_pay_password:'รีเซ็ตรหัสผ่านการชำระเงิน',
    reset_tip:'เพื่อความปลอดภัยของบัญชี โปรดป้อนรหัสผ่านการชำระเงินเดิมเพื่อยืนยันตัวตนของคุณ',
    forget_pay_password:'ลืมรหัสผ่านการชำระเงิน',
    set_pay_password:'ตั้งรหัสผ่านการชำระเงิน',
    enter_password:'กรุณาใส่รหัสผ่าน',
    enter_password2:'กรุณาป้อนอีกครั้ง',
    vcode:'รหัสยืนยัน',
    submit:'ยืนยัน',
    pay_password_wrong:'รหัสผ่านที่คุณป้อนไม่ถูกต้อง',
    fontSize:'ขนาดแบบอักษร'

  },
  news:{
    title:'เดลี่ เอ็กซ์เพรส',
    share:'แบ่งปัน',
    good:'ดี',
    bad:'แย่',
  },

  pin:{
    title:'ตั้งรหัส PIN',
    desc1:'เพื่อป้องกันความปลอดภัยของทรัพย์สินของคุณ โปรดตั้งรหัส PIN ก่อน รหัส PIN จะถูกใช้เพื่อปลดล็อกกระเป๋าเงินและส่งเหรียญ',
    desc2:'รหัส PIN เป็นรหัสผ่านในเครื่อง โปรดเก็บไว้ให้ถูกต้อง หากสูญหายจะไม่สามารถกู้คืนได้',
    close:'ปิดรหัส PIN',
    title2:'ยืนยัน PIN',
    tip2_1:'ลืมรหัส PIN ของคุณหรือไม่ หลังจากสำรองข้อมูลกระเป๋าเงินแล้ว ให้ติดตั้งแอปอีกครั้งและรีเซ็ตหลังจากนำเข้าวลีช่วยจำ'
  },
  google:{
    title:'การยืนยันของ Google',
    tip:'การยืนยันสองขั้นตอนของ Google สามารถเพิ่มชั้นการป้องกันให้กับบัญชีของคุณได้ เมื่อคุณเข้าสู่ระบบหรือทำธุรกรรม เมื่อคุณป้อนรหัสผ่าน คุณต้องมีรหัสยืนยันจากการยืนยันแบบสองขั้นตอนด้วย',
    help:'วิธีใช้การยืนยันสองขั้นตอนของ Google',
  },
  security:{
    title:'ระดับความปลอดภัย',
    title2:'ระดับความปลอดภัย',
    tip:'เพื่อความปลอดภัยของเงินของคุณ คุณต้องตั้งค่าความปลอดภัยเพิ่มเติมและข้อมูลชื่อจริงก่อนจึงจะสามารถถอนเหรียญได้ และขีดจำกัดการถอนจะเพิ่มขึ้นตามลำดับ',
    l3title:'เลือกประเภทเอกสาร',
    l3tip:'โปรดเลือกประเทศที่ออกใบรับรองของคุณ',
    c1:'อเมริกา',
    c2:'จีนแผ่นดินใหญ่',
    c3:'ประเทศจีน ฮ่องกง มาเก๊า และไต้หวัน',
    c4:'เกาหลีใต้',
    c5:'ญี่ปุ่น',
    c6:'สิงคโปร์',
    c7:'อื่น',
    nousdt: 'Your USDT balance is less than 3 and cannot undergo KYC authentication.',
  },
  realname:{
    title:'ข้อมูลการรับรอง',
    tip:'AuWallet กำหนดให้คุณต้องส่งบัตรประจำตัวที่มีรูปถ่ายที่ออกโดยรัฐบาลเพื่อผ่านการตรวจสอบความปลอดภัย',
    subtitle1:'แบบฟอร์มการสมัครสมาชิก 2U Token (2UT)',
    country:'ประเทศ',
    country_hint:'ประเทศที่คุณอาศัยอยู่',
    firstname:'ชื่อจริง',
    firstname_hint:'ชื่อจริงของคุณ',
    surname:'นามสกุล',
    surname_hint:'นามสกุลของคุณ',
    birthdate:'วันเกิด',
    cert_id:'หมายเลขประจำตัวประชาชน ',
    cert_id_hint:'หมายเลขประจำตัวของคุณ',
    id_photo1:'รูปหน้าบัตรประชาชน',
    id_photo2:'ID ย้อนกลับ photo',
    address:'ที่อยู่',
    address_hint:'ที่อยู่ปัจจุบันของคุณ',
    addr_photo:'หลักฐานที่อยู่',
    asset_photo:'หลักฐานแสดงทรัพย์สิน',
    subtitle2:'ใบรับรองคุณสมบัตินักลงทุน',
    tip1:'ฉันยืนยันว่าฉันมีคุณสมบัติตรงตามเกณฑ์อย่างน้อยหนึ่งข้อต่อไปนี้ และได้รับการรับรองว่าเป็นนักลงทุนที่มีคุณสมบัติโดยผู้ออกหลักทรัพย์ (ถ้ามี สามารถเลือกได้มากกว่าหนึ่งข้อ)',
    tip2:'หมายเหตุ (1): พอร์ตการลงทุน หมายถึง หลักทรัพย์และเงินสด ไม่รวมอสังหาริมทรัพย์',
    tip3:'หมายเหตุ (2): เอกสารที่มีใบแจ้งยอดรายเดือน สรุปการคำนวณ ฯลฯ จะต้องแนบมาในช่วง 3 เดือนที่ผ่านมา',
    invest_exp:'ประสบการณ์การลงทุน',
    other_exp:'อื่น',
    avg_volume:'ปริมาณ',
    avg_volume_hint:'ปริมาณธุรกรรมเฉลี่ยในช่วง 12 เดือนที่ผ่านมา (USD)',
    avg_num:'ตัวเลข',
    avg_num_hint:'จำนวนธุรกรรมเฉลี่ยในช่วง 12 เดือนที่ผ่านมา',
    exp_year:'ปีการลงทุน',
    exp_year_hint:'ประสบการณ์การลงทุนกี่ปี',
    net_asset:'สินทรัพย์สุทธิ',
    net_asset_hint:'มูลค่าทรัพย์สินสุทธิ (USD)',
    risk_tolerance:'การยอมรับความเสี่ยง',
    invest_term:'เงื่อนไขการลงทุนที่เหมาะสม',
    derivative:'อนุพันธ์',
    signature:'ลายเซ็น',
    reset:'รีเซ็ต',
    phone_number:'หมายเลขโทรศัพท์',
    submit:'ส่ง',
    option1_1:'ผู้ลงทุนรายบุคคลหรือรายบุคคลที่มีมูลค่าสุทธิสูงที่มีพอร์ตเงินสดและ/หรือหลักทรัพย์ไม่น้อยกว่า 20,000 เหรียญสหรัฐฯ (หรือเทียบเท่า) ในบัญชีร่วมกับคู่สมรสหรือบุตร',
    option1_2:'พอร์ตการลงทุนของบริษัทหรือห้างหุ้นส่วนไม่ต่ำกว่า 20,000 เหรียญสหรัฐ หรือสินทรัพย์รวมไม่น้อยกว่า 2 ล้านเหรียญสหรัฐ',
    option1_3:'นักลงทุนรายย่อยหรือบริษัทหรือห้างหุ้นส่วนที่มีมูลค่าสุทธิสูงเปิดบัญชีกับ De La O RuralBank Inc. และมีเงินไม่ต่ำกว่า 20,000 ดอลลาร์สหรัฐ ณ เวลาที่ลงนามในแบบฟอร์มการประเมินนี้',
    option2_1:'หลักทรัพย์',
    option2_2:'ฟิวเจอร์ส',
    option2_3:'การวาง',
    option2_4:'อื่น ๆ (โปรดระบุ)',
    option3_1:'สูง',
    option3_2:'กลาง',
    option3_3:'ต่ำ',
    option4_1:'มากกว่า 3 ปี',
    option4_2:'1-3 ปี',
    option4_3:'น้อยกว่า 1 ปี',
    option5_1:'ใช่',
    option5_2:'ไม่'
  },
  envelope:{
    title:'ซองจดหมายสีแดง',
    owned:'ซองจดหมายของฉัน',
    amount:'จำนวน',
    quantity:'ปริมาณ',
    quantity_hint:'ปริมาณซองจดหมาย',
    generate:'สร้าง',
    title2:'ส่งซอง',
    total:'จำนวนเงินรวมซองแดง',
    wishes:'ความปรารถนา',
    submit:'จ่าย',
    enter_pass:'กรุณากรอกรหัสผ่าน',
    choose_path:'เลือกวิธีการจัดส่ง',
    view:'ดูรายละเอียดซองจดหมายสีแดง',
    choose_coin:'เลือกเหรียญ',
    need_pay_password:'กรุณาตั้งรหัสผ่านการชำระเงินก่อน',
    share:'แบ่งปันซองจดหมายสีแดงกับเพื่อนของคุณ',
    title3:'บันทึกซองจดหมายสีแดง',
    num:'ปริมาณ',
  },
  mnemonic:{
    title:'ตัวช่วยจำกระเป๋าสตางค์สำรอง',
    tip:'ตัวช่วยจำคือคีย์ส่วนตัวซึ่งเป็นกุญแจสำคัญในการควบคุมทรัพย์สินของคุณ',
    tip1:'1. ประกอบด้วยอักขระ 12 ตัว โปรดคัดลอกและเก็บไว้ในที่ปลอดภัย',
    tip2:'2. 100% จะถูกเก็บไว้โดยคุณเมื่อสูญหายแล้วจะไม่สามารถเรียกคืนได้',
    tip3:'3. โปรดตรวจสอบให้แน่ใจว่าได้สำรองข้อมูลวลีช่วยในการจำให้เสร็จสิ้นก่อนที่จะรับสกุลเงินหรือถอนการติดตั้ง',
    backup:'การสำรองข้อมูลในขณะนี้',
    later:'ทำทีหลัง',
    tip4:'กรุณามองไปรอบๆ',
    tip5:'ใครก็ตามที่ได้รับการช่วยจำหมายความว่าพวกเขาได้รับทรัพย์สินของคุณ โปรดตรวจสอบให้แน่ใจว่าไม่มีใครอยู่รอบ ๆ และไม่มีกล้อง',
    understand:'เข้าใจแล้ว',     
    title2:'ดู Mnemonic',
    tip6:'คุณสามารถนำเข้าวลีช่วยจำเพื่อจับคู่บนอุปกรณ์อื่น หรือใช้กระเป๋าเงิน AuWallet บนอุปกรณ์อื่นเพื่อสแกนรหัส QR เพื่อจับคู่',
    tip7:'กรุณาอย่าจับภาพหน้าจอ! หากมีคนเข้าใจวลีช่วยจำของคุณ พวกเขาจะได้รับทรัพย์สินของคุณโดยตรง!',
    view_code:'ดูรหัส QR ที่เข้ารหัส',
    tip8:'การเข้ารหัสรหัส QR เป็นการอำนวยความสะดวกให้กระเป๋าเงินจับคู่กับอุปกรณ์ใหม่ โปรดอย่าถ่ายภาพหน้าจอและบันทึกภาพเหล่านั้น และตรวจสอบให้แน่ใจว่าไม่มีคนอื่นอยู่ใกล้ๆ หรือซ่อนกล้องไว้',
    tip9:'รหัส QR นี้สามารถใช้ได้โดยกระเป๋าเงิน AU เท่านั้น เมื่อสแกน คุณต้องป้อนรหัส PIN ของแอปปัจจุบันในแอปเพื่อนำเข้าเพื่อนำเข้าตัวช่วยจำที่สอดคล้องกัน',

    title3:'โปรดคัดลอกคำช่วยจำของ AuWallet',
    tip3_1:'วลีช่วยจำของ AuWallet ใช้เพื่อกู้คืนกระเป๋าเงิน โปรดคัดลอก 12 คำต่อไปนี้ลงบนกระดาษตามลำดับและบันทึกไว้ในที่ปลอดภัย',
    tip3_2:'กรุณาอย่าจับภาพหน้าจอ! หากมีคนเข้าใจวลีช่วยจำของคุณ พวกเขาจะได้รับทรัพย์สินของคุณโดยตรง!',
    save:'ฉันได้บันทึกไว้อย่างปลอดภัย',

    title4:'โปรดยืนยันวลีช่วยจำของ AuWallet',
    tip4_1:'เพื่อให้แน่ใจว่าคุณได้คัดลอกคำช่วยจำของ AuWallet อย่างถูกต้อง โปรดเลือกคำที่สอดคล้องกับหมายเลขซีเรียล',
    finish:'เสร็จ',
    next:'ถัดไป',
    verror:'ข้อผิดพลาดในการตรวจสอบความถูกต้อง',

    title5:'กู้คืน Mnemonic Wallet',
    tip5_1:'โปรดป้อนคำช่วยจำในแบบฟอร์มด้านล่างเพื่อตอบกลับกระเป๋าเงิน หลังจากป้อนคำช่วยจำแล้ว ให้กดปุ่ม "เว้นวรรค" เพื่อข้ามไปยังคำถัดไป',
    recover:'เริ่มการกู้คืน',
    ask:'เขียนทับกระเป๋าเงินปัจจุบัน?',
    tip5_2:"การนำเข้ากระเป๋าเงินจะเขียนทับกระเป๋าเงินปัจจุบัน หากคุณยังไม่ได้สำรองข้อมูล กระเป๋าเงินปัจจุบันจะหายไปตลอดกาล",
    tip5_3:'ฉันได้สำรองข้อมูลกระเป๋าเงินปัจจุบันของฉันแล้วและตกลงที่จะเขียนทับ',
    cancel:'ยกเลิก',
    import:'นำเข้าต่อไป',
    agree:'โปรดเลือกตกลง',
    create_success:'สร้างเรียบร้อยแล้ว',
    complete:'กรุณากรอกความจำให้ครบถ้วน',
  },
  invite:{
    title:'คำเชิญของฉัน',
    total:'หมายเลขคำเชิญ',
    invite_num:'จำนวนเพื่อนที่ลงทะเบียน',
    bonus1:'เพื่อนระดับ 1',
    every:'ต่อคน',
    bonus2:'เพื่อน 2 ระดับ',
    bonus3:'เพื่อน 3 ระดับ',
    deposit:'จำนวนเพื่อนฝากเหรียญ',
    list:'รายการเชิญ',
    subtitle1:'การลงทะเบียน',
    subtitle2:'เงินฝาก',
    no_records:'ยังไม่มีคำเชิญ'
  },
  lang:{
    set_lang:'ตั้งค่าภาษา',
  },
  setting:{
    tip:"ระบบซื้อขายในสกุลเงินดอลลาร์สหรัฐฯ จริง และระบบจะแปลงราคาค่าคอมมิชชันของผู้ใช้เป็นดอลลาร์สหรัฐโดยอัตโนมัติที่อัตราแลกเปลี่ยนล่าสุด ราคาค่าคอมมิชชันที่แท้จริงอาจแตกต่างจากราคาที่ผู้ใช้ป้อนเล็กน้อย"
  },
  send:{
    title:'ประเภทการโอน',
    t1:'การโอนบล็อคเชน',
    t2:'โอนภายใน',
  },
  sortable:{
    title:'เรียงลำดับเอง',
    drag_to_sort:'ลากเพื่อจัดเรียง',
    currency:'สกุลเงิน'
  },
  system:{
    flushing:'ฟลัชชิง...',
    loading:'กำลังโหลด...',
    btn1:'ยืนยัน',
    btn2:'ยกเลิก',
    add:'เพิ่ม',
    search:'ค้นหา',
    topPullText:'ดึงลงเพื่อรีเฟรช',
    topDropText:'ปล่อยรีเฟรช',
    topLoadingText:'กำลังโหลด...',
    copy_succ:'คัดลอกสำเร็จ',
    copy_fail:'คัดลอกไม่สำเร็จ',
    about:'About'
  },
  share:{
    title:'แบ่งปัน',
    download:'สแกนรหัสเพื่อดาวน์โหลด AuWallet',
    sharecode:'รหัสเชิญ (คลิกเพื่อคัดลอก):',
    view_invites:'ดูรายละเอียดคำเชิญ',
    copy_link:'คัดลอกลิงค์',
    attention:'คัดลอกลิงก์ด้านบน วางลงในเบราว์เซอร์มือถือของคุณ แล้วเปิดเพื่อดาวน์โหลด AuWallet'
  },
  wealth:{
    tit:"ทรัพย์สิน",
    title:'ความมั่งคั่งของฉัน',
    title1:'การขุด',
    title2:'แผนเหรียญ',
    hot:'คำแนะนำยอดนิยม',
    plan1:'แผนออนดีมานด์',
    plan2:'แผนถาวร',
    annu_return:'ผลตอบแทนรายปี',
    in_amount:'จำนวนเงินใน',
    transfer_all:'ทั้งหมด',
    view_rules:'ดูกฎ',
    pay_password:'กรุณาใส่รหัสผ่านการชำระเงิน',
    asset:'ความมั่งคั่ง',
    search:'สอบถามธุรกรรม',
    rules:'กฎ',
    order_time:'เวลาสั่ง',
    value_date:'วันที่มีค่า',
    expiry_date:'วันหมดอายุ',
    highlights:'ไฮไลท์',
    remaining_quota:'โควต้าที่เหลือ',
    buy:'ซื้อเลย',
    ystday_earnings:"รายได้เมื่อวาน",
    total_earnings:'รายได้รวม',
    transfer_in:'ใน',
    transfer_out:'ออก',
	transfer_outed:'ไถ่ถอน',
    tran_all:'ทั้งหมด',
    tran_in:'ใน',
    tran_out:'ออก',
    tran_earning:'รับรายได้',
    prod_all:'ทั้งหมด',
    prod1:'การขุด PoS',
    prod2:'แผนเหรียญ',
    curr_all:'ทั้งหมด',
    out_amount_tip:'กรุณาระบุจำนวนเงินที่โอน',
    send:'ส่ง',
    success:'ความสำเร็จ',
    amount_tip:'กรุณากรอกจำนวนเงิน',
  },
  ads:{
    title:'ข่าวดี',
    content:'U2U ขายร้อน',
    content2:'2UT ขายร้อน',
    buy:'ซื้อ',
    plan_name:'U2U การออกหุ้นใหม่',
    tip: 'U2U is 10% off!'
  },
  buyuut: {
    maxtip: 'Each person can buy a maximum of 100',
    current: 'Current',
    price: 'Price',
    discount: 'Discount',
    off: 'OFF',
    amountlabel: 'Purchase quantity',
    maxerror: 'You can\'t buy more than 100',
    totalprice: 'Total Price',
    balance: 'Balance',
    purchase: 'Purchase',
    rulestitle: 'Rules of Activity'
  },
  receive:{
	  fuzhicg:'การประสบความสำเร็จ',
	  fuzhicc:'การล้มเหลว',
  },
  alert:{
  	  cancel:'ยกเลิก',
  	  confirm:'ยืนยัน'
  },
  against:{
		  no100: 'USDT ต้องหลายร้อย'
	},
	package:{
		  title: 'ห่อของ',
		  amount: 'จำนวนรวม',
		  time: 'กาละ',
		  coin: 'Token',
		  price: 'ราคา',
		  scale: 'เกล็ดปลา',
		  quantity: 'จำนวนรวม',
		  submit: 'ทูลเกล้าฯถวาย',
		  total: 'ทั้งหมด',
		  points: 'จุดสำคัญ',
		  balance: 'เหี้ยนเตียน',
		  apoints: 'จุดว่าง:',
		  apoints2: 'รายได้จากความมั่งคั่งที่มีอยู่',
		  abalance: 'ดุลพร้อมใช้งาน(USDT):',
		  abalance2: 'ดุลพร้อมใช้งานู่(U2U):',
		  import: 'นำเข้า',
		  orders: 'คำสั่ง',
		  orders_detail: 'รายละเอียดการสั่งซื้อ',
		  defi: 'DEFI',
		  nopoint: 'แลกเปลี่ยนมากกว่าจุดที่มีอยู่',
		  nobalance: 'การไถ่ถอนเกินดุลที่มีอยู่',
		  nologin: 'เข้าสู่ระบบหมดอายุแล้วกรุณาเข้าสู่ระบบอีกครั้ง',
		  pay_type: 'ประเภทของการชำระเงิน'
	},
	nasdaq:{
		  label :'(IPO)Stock pre purchase application',
		  label2 :'Number of (IPO)stock exchange applications',
		  apply :'Apply',
		  applyed :'Applied',
		  background :'Background Description',
		  text :'1. The formal plan must meet the requirements that the NASDAQ stock reform documents submitted by (relevant stocks) are received and entered into the countdown process for submission.<br />2. During the official review process of NASDAQ (related stocks), there is no rule out the possibility of rejection or extension of time.',
		  cancel: 'Cancel',
		  submit: 'Submit',
	},
	ysjjy: "(Based on actual transactions)"

}
